import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-priority",
	templateUrl: "./priority.component.html",
})
export class PriorityComponent implements OnInit {
	@Input() priorite: string;
	constructor() {}

	ngOnInit() {}
}
